import { render, staticRenderFns } from "./Profiledata.vue?vue&type=template&id=0eb5da42"
import script from "./Profiledata.vue?vue&type=script&lang=js"
export * from "./Profiledata.vue?vue&type=script&lang=js"
import style0 from "./Profiledata.vue?vue&type=style&index=0&id=0eb5da42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports